import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import StarUpdateFormLayer from "../components/StarUpdateFormLayer";

const StarUpdateFormPage = () => {
  return (
    <MasterLayout>
      <StarUpdateFormLayer />
    </MasterLayout>
  );
};

export default StarUpdateFormPage;
